import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { DataProtectionNoticeItemFacade } from './data-protection-notice-item.facade';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class DataProtectionNoticeItemGuard {
  constructor(private dpnItemFacade: DataProtectionNoticeItemFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { dpnItemId },
    } = route;
    return checkStoreState(this.dpnItemFacade, dpnItemId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.dpnItemFacade);
  }
}
